import {apiGet, apiPost} from './index'

export const getQuestionDetail = (id) => apiGet(`/api/survey/${id}`)

export const surveySubmission = (params) => apiPost('/api/surveySubmission', params)

export const getSurveyShowUserId = (userId) => apiGet(`/api/survey/show/${userId}`)

export const getSurveySubmissionApi = (submissionId) => apiGet(`/api/surveySubmission/answer/get/${submissionId}`)



// WEBPACK FOOTER //
// ./src/api/questionnaire.js